import { HelpOutline as HelpIcon } from '@mui/icons-material';
import { Tooltip, TooltipProps } from '@mui/material';

type Props = Omit<TooltipProps, 'children'> & {
  iconTestId?: string;
};

export const HelpTooltip = ({ iconTestId, ...tooltipProps }: Props) => (
  <Tooltip {...tooltipProps}>
    <HelpIcon
      data-testid={iconTestId}
      fontSize="small"
      color="secondary"
      sx={{ ml: 1 }}
    />
  </Tooltip>
);
